export const footer_i18n = {
    text1: "Confidentialité",
    text2: "Conditions",
    text3: "Plan du site"
};